import axios from "axios";
import { CatalogueHeaderData, HeaderData } from "./headerApi.types";

const baseUrl = '/api/header';
const getHeaderUrl = `${baseUrl}/getHeader`;
const getProductCatalogueHeader = `${baseUrl}/getProductCatalogueHeader`;

export const getHeaderModel = async( currentPageId ): Promise<HeaderData> => {
  const response = await axios.get<HeaderData>(getHeaderUrl, {
    params: {
      currentPageId: currentPageId,
    }
  });

  return response.data;
}

export const getProductCatalogueHeaderModel = async( currentPageId ): Promise<CatalogueHeaderData> => {
  const response = await axios.get<CatalogueHeaderData>(getProductCatalogueHeader, {
    params: {
      currentPageId: currentPageId,
    }
  });

  return response.data;
}